import React from 'react';
import { Fab, FabProps } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export interface FloatingActionButtonProps extends Omit<FabProps, 'children'> {
  onClick: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onClick, ...rest }) => {
  return (
    <Fab
      color="primary"
      aria-label="add"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1000,
      }}
      {...rest} // ✅ Now correctly typed per MUI's FabProps
    >
      <AddIcon />
    </Fab>
  );
};

export default FloatingActionButton;
